import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { cloneElement, useState } from "react";
import { useToggle } from "usehooks-ts";
import { Dialog } from "./Dialog";
export const ConfirmationDialog = (props)=>{
    const [isDialog, toggleDialog] = useToggle();
    const [typedText, setTypedText] = useState('');
    const isControlled = props.isOpen !== undefined;
    const isOpen = isControlled ? props.isOpen : isDialog;
    const onCancel = ()=>{
        props.onCancel?.();
        setTypedText('');
        if (!isControlled) toggleDialog();
    };
    const onConfirm = (e)=>{
        /* the dialog portals to document.body, so this submit isn't inside any
       ancestor <form> in the DOM, but React still bubbles it through the
       component tree — stopPropagation keeps it from also submitting a
       react-hook-form <Form> that renders this dialog as a descendant */ e?.preventDefault();
        e?.stopPropagation();
        if (!!props.confirmationText && typedText !== props.confirmationText) return;
        props.onConfirm();
        setTypedText('');
        if (!isControlled) toggleDialog();
    };
    const onOpen = (e)=>{
        props.onOpen?.(e);
        if (!isControlled) toggleDialog();
    };
    const triggerWithProps = props.trigger ? /*#__PURE__*/ cloneElement(props.trigger, {
        //@ts-expect-error: bug in types
        'aria-haspopup': 'dialog',
        'data-testid': props['data-testid'] ?? 'confirmation',
        onClick: onOpen
    }) : null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            triggerWithProps,
            /*#__PURE__*/ _jsx(Dialog, {
                "data-component": "confirmationDialog",
                "data-testid": props['data-testid'] ?? 'confirmation',
                isOpen: isOpen,
                onClose: onCancel,
                children: /*#__PURE__*/ _jsxs("form", {
                    noValidate: true,
                    onSubmit: onConfirm,
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            variant: "h3",
                            children: props.title
                        }),
                        /*#__PURE__*/ _jsxs(DialogContent, {
                            children: [
                                typeof props.message === 'string' ? /*#__PURE__*/ _jsx(DialogContentText, {
                                    children: props.message
                                }) : props.message,
                                props.confirmationText && /*#__PURE__*/ _jsx(TextField, {
                                    autoComplete: "off",
                                    fullWidth: true,
                                    inputProps: {
                                        'data-1p-ignore': true,
                                        'data-component': 'input',
                                        'data-testid': 'confirmationTextInput'
                                    },
                                    label: `Type '${props.confirmationText}' to confirm`,
                                    onChange: (e)=>setTypedText(e.target.value),
                                    size: "small",
                                    sx: {
                                        mt: 2
                                    },
                                    value: typedText
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(DialogActions, {
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    "data-testid": "cancel",
                                    onClick: onCancel,
                                    variant: "outlined",
                                    children: props.cancelText ?? 'Cancel'
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    color: props.confirmColor,
                                    "data-testid": "confirm",
                                    disabled: !!props.confirmationText && typedText !== props.confirmationText,
                                    type: "submit",
                                    variant: "contained",
                                    children: props.confirmText ?? 'Confirm'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
ConfirmationDialog.displayName = 'ConfirmationDialog';

//# sourceMappingURL=ConfirmationDialog.js.map